module.exports = __webpack_public_path__ + "img/rossen.2faf82c9.jpg";